import { forwardRef, useState, type InputHTMLAttributes } from 'react';
import { centsToInput, parseBRL } from '../format';
import { Input } from './field';

interface MoneyInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'defaultValue'> {
  value: number | null | undefined;
  onChange: (cents: number | null) => void;
}

/** Campo de valor em reais que entrega centavos inteiros. */
export const MoneyInput = forwardRef<HTMLInputElement, MoneyInputProps>(function MoneyInput({ value, onChange, onBlur, ...rest }, ref) {
  const [text, setText] = useState(() => centsToInput(value));
  const [lastValue, setLastValue] = useState(value);
  if (value !== lastValue) {
    setLastValue(value);
    if (parseBRL(text) !== value) setText(centsToInput(value));
  }
  return (
    <div className="relative">
      <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm text-muted">R$</span>
      <Input
        ref={ref}
        inputMode="decimal"
        className="pl-9 tabular-nums"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          onChange(parseBRL(e.target.value));
        }}
        onBlur={(e) => {
          const cents = parseBRL(text);
          if (cents !== null) setText(centsToInput(cents));
          onBlur?.(e);
        }}
        {...rest}
      />
    </div>
  );
});
